import { store } from '../../App'
export const FAIL_FETCH = 'FAIL_FETCH'
export const FETCH_PUSH_CONTENT_NOTIFICATIONS = 'FETCH_PUSH_CONTENT_NOTIFICATIONS'
export const LOAD_PUSH_CONTENT_NOTIFICATIONS = 'LOAD_PUSH_CONTENT_NOTIFICATIONS'
export const FETCH_PUSH_ALERT_NOTIFICATIONS = 'FETCH_PUSH_ALERT_NOTIFICATIONS'
export const LOAD_PUSH_ALERT_NOTIFICATIONS = 'LOAD_PUSH_ALERT_NOTIFICATIONS'
export const FETCH_PUSH_EVENT_NOTIFICATIONS = 'FETCH_PUSH_EVENT_NOTIFICATIONS'
export const LOAD_PUSH_EVENT_NOTIFICATIONS = 'LOAD_PUSH_EVENT_NOTIFICATIONS'
export const FETCH_PUSH_SMS_NOTIFICATIONS = 'FETCH_PUSH_SMS_NOTIFICATIONS'
export const LOAD_PUSH_SMS_NOTIFICATIONS = 'LOAD_PUSH_SMS_NOTIFICATIONS'
/**
 * failFetch
 * @desc Fail Fetch Action Generator
 * @param {Object} error
 * @return {action} failFetchAction
 */
export function failFetch (error) {
  return { type: FAIL_FETCH, error }
}
/**
 * fetchPushNotifications
 * @param {string} ID
 * @param {timestamp} start
 * @param {timestamp} end
 * @param {Object} options
 * @return {action} fetchPushNotificationsAction
 */
export function fetchPushNotifications (ID, start, end, options) {
  const query = { accountId: ID, startDate: start, endDate: end }
  if (options.deviceType) {
    query.deviceType = options.deviceType
  } else {
    query.deviceType = 'ALL'
  }
  if (options.pushNotificationType) {
    query.pushNotificationType = options.pushNotificationType
  } else {
    query.pushNotificationType = 'CONTENT'
  }
  if (options.limit) {
    query.limit = options.limit
  }
  if (options.sort) {
    query.sort = options.sort
  }
  if (options.offset) {
    query.offset = options.offset
  } else query.offset = 0
  if (options.profile && options.profile[0] && options.profile[0].length > 0) {
    query.appProfileIds = options.profile
  } else {
    if (store.getState().filterSources.profiles[0] && store.getState().filterSources.profiles[0]._id === '0') {
      return { type: FAIL_FETCH }
    }
    query.appProfileIds = store.getState().filterSources.profiles.map(profile => profile._id)
  }
  if (options.group && options.group[0] && options.group[0].length > 0) {
    query.groupIds = options.group
  } else {
    if (store.getState().filterSources.profiles[0] && store.getState().filterSources.profiles[0]._id === '0') {
      return { type: FAIL_FETCH }
    }
    // query['groupIds'] = []
    // store.getState().filterSources.profiles.forEach((profile) => {
    //   query['groupIds'] = [...new Set([].concat(...[query['groupIds'], profile.groups]))]
    // })
    query.groupIds = ['AllGROUPS']
  }

  let type = FETCH_PUSH_CONTENT_NOTIFICATIONS
  if (options.pushNotificationType === 'EVENT') {
    type = FETCH_PUSH_EVENT_NOTIFICATIONS
  }
  if (options.pushNotificationType === 'ALERT') {
    type = FETCH_PUSH_ALERT_NOTIFICATIONS
  }
  if (options.pushNotificationType === 'SMS') {
    type = FETCH_PUSH_SMS_NOTIFICATIONS
  }
  return { type, query }
}
/**
 * loadPushNotifications
 * @param {Object} data
 * @param {String} type
 * @return {action} loadPushNotificationsAction
 */
export function loadPushNotifications (data, type) {
  return { type, data }
}
